import templateUrl from './image-crop.html';

export class ImageCropService {
    constructor(ModalService) {
        'ngInject';

        this.modalService = ModalService;
    }
    typeConfig(type){
        if(type === "cover"){
            return {
                areaType : 'rectangle',
                aspectRatio : 1.7,
                resultImageSize : {w: 340,h: 200}
            }
        } else if(type === "profile"){
            return {
                areaType : 'square',
                aspectRatio : 1,
                resultImageSize : {w: 200, h: 200}
            }
        } else if(type === "banner") {
            return {
                areaType : 'rectangle',
                aspectRatio : 2.52,
                resultImageSize : {w: 1920, h: 760}
            }
        } else if(type === "staffProfile") {
            return {
                areaType : 'rectangle',
                aspectRatio : 0.75,
                resultImageSize : {w: 200, h: 266}
            }
        }
    } 

    cropImage(details) {
        const modalInstane = this.modalService.open({
            details: {
                image: details.image,
                config : this.typeConfig(details.type),
                onCancel: () => {
                    modalInstane.close();
                    if(details.onCancel) {
                        details.onCancel();
                    }
                },
                onCrop: (image) => {
                    if(details.onCrop) {
                        modalInstane.close();
                        details.onCrop(image);
                    }
                }
            },
            backdrop: 'static',
            keyboard: true,
            templateUrl
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/common/libs/image-crop/image-crop.service.js